import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { dynamicTableStore } from "features/DynamicTable/DynamicTableStore";

const DynamicTableFooter = () => {
  const { t } = useTranslation();

  return (
    <div
      className={clsx(
        "text-sm font-medium bg-gray-50 text-gray-500 p-2",
        "border-t border-gray-300 w-full z-2"
      )}
    >
      {t(
        dynamicTableStore.filterStore.hasGrouping()
          ? "mappingEditor.groupesLoadedStatus"
          : "mappingEditor.objectsLoadedStatus",
        {
          objects: dynamicTableStore.data.items.length,
          total: dynamicTableStore.data.count,
        }
      )}
    </div>
  );
};

export default observer(DynamicTableFooter);
